export enum RcsAgentBasicsStatus {
  Submitted = "SUBMITTED",
  Approved = "APPROVED",
  Rejected = "REJECTED",
}
